import Skeleton from 'react-loading-skeleton';

import Help from './Help/Help';
import styles from './SidePanelLoader.module.css';
import useWindowDimensions from '../../hooks/useWindowDimensions';

const SidePanelLoader = () => {
  const { isMobile } = useWindowDimensions();

  return (
    <>
      <div data-testid="side-panel-loader">
        <h2 className={styles.heading}>
          <Skeleton
            baseColor="var(--color-structure-60)"
            width="100%"
            height={124}
          />
        </h2>
        <div className={styles.completionSteps}>
          <Skeleton
            baseColor="var(--color-structure-60)"
            width="100%"
            height={160}
          />
        </div>
        {!isMobile && <Help loading={true} />}
      </div>
      {!isMobile && (
        <div className={styles.footer}>
          <Skeleton
            baseColor="var(--color-structure-60)"
            width="100%"
            height={110}
          />
        </div>
      )}
    </>
  );
};

export default SidePanelLoader;
